<template>
  <!-- 课程安排 -->
  <div class="virtualsimulation">
    <div class="search">
      <div class="leftcontain">
        <div class="left1">
          <div class="text">关键字:</div>
          <el-input
            class="elinput"
            size="medium"
            v-model="queryParams.keyword"
            placeholder="请输入课程名/实验名/指导老师"
          >
            <i class="el-icon-search el-icon_search" slot="suffix"></i>
          </el-input>
        </div>
        <div class="left2">
          <div class="text">起始周:</div>
          <el-select
            class="elselect"
            size="medium"
            v-model="queryParams.start_week"
            placeholder="请选择"
          >
            <el-option v-for="item in weeknum" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="left2">
          <div class="text">截止周:</div>
          <el-select
            class="elselect"
            size="medium"
            v-model="queryParams.end_week"
            placeholder="请选择"
          >
            <el-option v-for="item in weeknum" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <div class="rightcontain">
        <el-button class="bt bt1" @click="reset">重置</el-button>
        <el-button class="bt" @click="search">查询</el-button>
      </div>
    </div>

    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      style="width: 100%"
      class="Table"
      :header-cell-style="{
        'font-size': '15px',
        color: '#666666',
        'font-weight': 'bold',
        background: '#F7F7F7',
      }"
      :row-style="{
        'font-size': '15px',
        color: '#222222',
        'font-weight': '400',
      }"
    >
      <el-table-column prop="course_lib_name" label="课程名称"></el-table-column>
      <el-table-column prop="experiment_name" label="实验名称"></el-table-column>
      <el-table-column prop="week_number" label="周次"></el-table-column>
      <el-table-column prop="day" label="星期"></el-table-column>
      <el-table-column prop="lesson" label="节次"></el-table-column>
      <el-table-column prop="address" label="实验地点"></el-table-column>
      <el-table-column prop="teacher_name" label="指导老师"></el-table-column>
    </el-table>
    <div class="elpagination">
      <div class="elpagination-title">共{{ total }}条</div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getmysinglelessonlist } from "@/api/courselibweeklylesson"
export default {
  name: "virtualsimulation",
  components: {

  },
  data () {
    return {
      total: 0,
      weeknum: "",
      tableData: [],
      queryParams: {
        page: 1,
        per_page: 10,
        course_lib_id: '',
        keyword: '',
        start_week: '',
        end_week: ''
      }
    }
  },
  methods: {
    reset () {
      this.queryParams.page = 1
      this.queryParams.per_page = 10
      this.queryParams.keyword = ''
      this.queryParams.start_week = ''
      this.queryParams.end_week = ''
      this.getmysinglelessonlist()
    },
    search () {
      this.queryParams.page = 1
      this.getmysinglelessonlist()
    },
    initdata (item, weeknum) {
      this.weeknum = parseInt(weeknum)
      this.queryParams.course_lib_id = item.id
      this.getmysinglelessonlist()
    },
    changePage (val) {
      this.queryParams.page = val
      this.getmysinglelessonlist()
    },
    getmysinglelessonlist () {
      getmysinglelessonlist(this.queryParams)
        .then((response) => {
          this.tableData = response.data.data
          this.total = response.data.total
        })
        .catch((error) => {
          //console.log(error)
        })
    },
  },
};
</script>
<style scoped lang="scss">
.virtualsimulation {
  // background: #fff;
  .search {
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    background: #fcfcfc;
    border: 1px solid #ececec;
    .leftcontain {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .left1 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .text {
          margin-right: 10px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #888888;
        }
        .elinput {
          width: 220px;
          ::v-deep .el-input__suffix {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .left2 {
        margin-left: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .text {
          margin-right: 10px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #888888;
        }
        .elselect {
          width: 200px;
        }
      }
    }
    .rightcontain {
      display: flex;
      justify-content: center;
      align-items: center;
      .bt {
        width: 64px;
        height: 38px;
        line-height: 38px;
        padding: 0px;
        border: 1px solid #3d84ff;
        background: #3d84ff;
        color: white;
      }
      .bt1 {
        margin-left: 10px;
        background: white;
        color: #3d84ff;
      }
    }
  }

  .Table {
    padding: 10px;
    margin-top: 30px;
    width: 100%;

    .bt {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #26b5ff;
      user-select: none;
      cursor: pointer;
      padding: 0px;
      margin: 0px;
    }
  }
  .elpagination {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    .elpagination-title {
      margin-right: 4px;
    }
  }
}
</style>
